export const state = {
    activated: false,
    is_buying_pack: true,
    last_payment_method: null,
};

export default state;
